<template>
  <div class="faq-area ptb-100">
    <div class="container">
      <div class="section-title">
        <span class="sub-title">Perguntas Frequentes</span>
        <h2>Tire suas dúvidas sobre o RaptorCRM</h2>
      </div>
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-12">
          <div class="faq-accordion">
            <div class="accordion" id="faqAccordion">
              <div class="accordion-item" data-aos="fade-up" data-aos-duration="1200">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  O que é um CRM e como pode ajudar minha empresa?
                </button>
                <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#faqAccordion">
                  <div class="accordion-body">
                    <p>CRM significa Customer Relationship Management (Gestão de Relacionamento com Cliente). O RaptorCRM ajuda você a organizar todos os seus contatos, acompanhar negócios, automatizar tarefas e aumentar suas vendas de forma eficiente.</p>
                  </div>
                </div>
              </div>
              <div class="accordion-item" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  Quanto tempo leva para implementar o RaptorCRM?
                </button>
                <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div class="accordion-body">
                    <p>A implementação é rápida e simples! Em menos de 1 hora você já pode estar utilizando o sistema. Nossa equipe oferece suporte completo durante todo o processo de configuração e migração dos seus dados.</p>
                  </div>
                </div>
              </div>
              <div class="accordion-item" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  Posso integrar o RaptorCRM com outras ferramentas?
                </button>
                <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div class="accordion-body">
                    <p>Sim! O RaptorCRM se integra com WhatsApp, email marketing, sistemas de pagamento, planilhas do Google, e centenas de outras ferramentas através de nossa API robusta e integrações nativas.</p>
                  </div>
                </div>
              </div>
              <div class="accordion-item" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="300">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                  Meus dados estão seguros no RaptorCRM?
                </button>
                <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div class="accordion-body">
                    <p>Absolutamente! Utilizamos criptografia SSL de 256 bits, backup automático diário, servidores em nuvem seguros e seguimos rigorosamente a LGPD. Seus dados estão protegidos com a mais alta segurança.</p>
                  </div>
                </div>
              </div>
              <div class="accordion-item" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="400">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                  Posso cancelar minha assinatura a qualquer momento?
                </button>
                <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div class="accordion-body">
                    <p>Sim! Não há fidelidade. Você pode cancelar sua assinatura a qualquer momento através do painel administrativo ou entrando em contato com nosso suporte. Seus dados podem ser exportados antes do cancelamento.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="faq-image style-three" data-aos="fade-up">
            <img src="../../assets/images/faq3.png" alt="faq-image">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Faq',
}
</script>